import React, { useEffect, useRef } from 'react';

interface MiniPreviewProps {
  pixels: number[][] | null;
  colors: string[];
  scale?: number;          // default 4
  label?: string;
  hidden?: boolean;        // pass isMobile to hide on mobile
  secondaryColors?: string[]; // NEW
}

const MiniPreview: React.FC<MiniPreviewProps> = ({
  pixels,
  colors,
  scale = 4,
  label = 'Preview',
  hidden,
  secondaryColors, 
}) => {
  const ref = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    if (!pixels || hidden || !ref.current) return;
    const size = pixels.length;
    const cvs = ref.current;
    cvs.width = size;
    cvs.height = size;
    const ctx = cvs.getContext('2d');
    if (!ctx) return;
    ctx.imageSmoothingEnabled = false;
    ctx.clearRect(0, 0, size, size);

    const resolve = (ci: number) => {
      const isSec = (ci & 0x80) !== 0 || ci < 0;
      const base = ci < 0 ? (ci + 16) & 0x0f : (ci & 0x0f);
      const sec = secondaryColors ?? colors;
      return isSec ? (sec[base] ?? colors[base] ?? '#000') : (colors[base] ?? '#000');
    };

    for (let y = 0; y < size; y++) {
      for (let x = 0; x < size; x++) {
        const ci = pixels[y][x] ?? 0;
        ctx.fillStyle = resolve(ci);
        ctx.fillRect(x, y, 1, 1);
      }
    }
    cvs.style.width = `${size * scale}px`;
    cvs.style.height = `${size * scale}px`;
  }, [pixels, colors, scale, hidden, secondaryColors]);

  if (hidden || !pixels) return null;

  return (
    <div className="mini-preview" aria-label={label}>
      <span className="mini-preview-label">{label}</span>
      <canvas ref={ref} className="mini-preview-canvas" />
    </div>
  );
};

export default MiniPreview;